define("command-palette/services/command-palette", ["exports", "@ember/runloop", "@ember/service", "command-palette/constants", "command-palette/utils/search-commands-query", "command-palette/utils/search-commands-result", "tracked-built-ins"], function (_exports, _runloop, _service, _constants, _searchCommandsQuery, _searchCommandsResult, _trackedBuiltIns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.CommandPaletteService = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"@ember/runloop",0,"@ember/service",0,"command-palette/constants",0,"command-palette/utils/search-commands-query",0,"command-palette/utils/search-commands-result",0,"tracked-built-ins"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const SEARCH_DEBOUNCE_MS = 100;
  let CommandPaletteService = _exports.CommandPaletteService = (_dec = (0, _service.inject)('command-palette/private/command-registry'), (_class = class CommandPaletteService extends _service.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "commandRegistry", _descriptor, this);
      _initializerDefineProperty(this, "isOpen", _descriptor2, this);
    }
    get commands() {
      return Object.values(this.commandRegistry.commands);
    }
    get commandIds() {
      return Object.keys(this.commandRegistry.commands);
    }

    /**
     * Search for available commands.
     * @param query
     * @returns Command search results
     */
    search(query) {
      return new Promise(resolve => {
        (0, _runloop.debounce)(this, this.resolveSearch, query, resolve, SEARCH_DEBOUNCE_MS);
      });
    }
    closeSearchModal() {
      this.isOpen = false;
    }
    openSearchModal() {
      this.isOpen = true;
    }
    parseQuery(query) {
      return (0, _searchCommandsQuery.parseQuery)(query);
    }
    runCommand(commandId, query) {
      const command = this.commandRegistry.commands[commandId];
      if (!command) {
        throw new Error(`Unable to run command with ID "${commandId}" because it hasn't been registered`);
      }
      void command.execute(query);
    }
    getSuggestedSearchResults() {
      const fakeQuery = {
        raw: '',
        normalized: '',
        parts: [''],
        tokens: {
          mentions: [''],
          tags: [''],
          text: ['']
        }
      };
      return this.commands.filter(command => command.isAvailable() && command.isSuggested() === true).map(command => {
        return {
          commandId: command.commandId,
          score: 100,
          title: command.getTitle(fakeQuery),
          description: command.getDescription(fakeQuery),
          icon: command.getIcon(fakeQuery),
          type: _constants.SearchCommandResultType.Suggested
        };
      });
    }
    resolveSearch(query, resolve) {
      const searchIntents = this.getSearchCommandsForQuery(query.normalized);
      const searchResults = this.getSearchResultsForQuery(query, searchIntents);
      const sortedSearchResults = searchResults.sort((a, b) => b.score - a.score);
      resolve(sortedSearchResults);
    }
    getSearchCommandsForQuery(normalizedQuery) {
      const commands = this.commands.filter(command => {
        if ((0, _searchCommandsResult.meetsSearchRequirements)(normalizedQuery, command.mandatoryTerms)) {
          return (0, _searchCommandsResult.isPartialMatch)(normalizedQuery, command.searchTerms);
        }
        return false;
      });
      return commands;
    }
    getSearchResultsForQuery(query, commands) {
      return commands.filter(command => command.isAvailable()).map(command => {
        const score = (0, _searchCommandsResult.scoreSearchResult)(query.normalized, command);
        return {
          commandId: command.commandId,
          score,
          title: command.getTitle(query),
          description: command.getDescription(query),
          icon: command.getIcon(query),
          type: _constants.SearchCommandResultType.Live
        };
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "commandRegistry", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class));
  var _default = _exports.default = CommandPaletteService;
});